module.exports = __webpack_public_path__ + "img/danghui.57357e4f.svg";